import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';

import { fetchAuthenticated } from 'services/fetch';
import { emitEvent } from 'utils/events';

import ReferencePointForm from 'components/forms/ReferencePointForm';
import ModalRemove from 'components/modals/ModalRemove';
import { logAction } from 'utils/logs';

const useStyles = makeStyles({
  overlay: {
    position: "absolute",
    height: "100%",
    mouseEvents: "none"
  }
});

function EditFence(props) {
  const classes = useStyles();
  const { history, match, setBreadcrumbs } = props;
  const [referencePoint, setReferencePoint] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [loadingDialog, setLoadingDialog] = useState(false);

  // Use base fence url
  const referencePointURL = `reference-point/${match.params.id}`;

  // Set breadcrumbs
  useEffect(() => {
    setBreadcrumbs([
      { path: `/fence`, label: `Cercas` },
      { path: ``, label: `${referencePoint && referencePoint.name || ''}` }
    ]);
    return () => { setBreadcrumbs([]); }
  }, [setBreadcrumbs, match.params.id, referencePoint]);

  // Load fence info
  useEffect(() => {
    const fn = async () => {
      emitEvent('showGlobalLinearProgress');

      const response = await fetchAuthenticated('get', referencePointURL);

      // Any erro will redirect to companies list
      if (response.status >= 400) {
        emitEvent('showSnack', { message: 'Não foi possível realizar esta ação', type: 'error' });
        history.push('/cercas');
      } else {
        const data = await response.json();

        setReferencePoint(data);
        logAction(`Acesso ao cadastro do ponto de referência ${data.name}`)
        emitEvent('hideGlobalLinearProgress');
      }
    }; fn();
  }, [history, referencePointURL])

  // Handle form submission
  const handleSubmit = async (data) => {
    const response = await fetchAuthenticated('put', referencePointURL, data);

    if (!response.ok) {
      throw new Error('')
    } else {
      const data = await response.json();
      setReferencePoint(data);
      logAction(`Edição da cerca ${data.name}`);
      emitEvent('showSnack', { message: 'Cerca atualizada com sucesso', type: 'success' });
    }
  }

  // Handle cancel button click
  const handleCancel = (event) => {
    history.push('/cercas/pontosdereferencia');
  }

  // Handle remove button click
  const handleRemove = (event) => {
    setShowDialog(true);
  }

  // Update show dialog variable to close modal
  const handleDialogClose = () => {
    setShowDialog(false);
  }

  const handleRemoveConfirm = async () => {
    setLoadingDialog(true);
    let redirect = false;
    try {
      const response = await fetchAuthenticated('delete', referencePointURL);

      if (response.status >= 400) {
        emitEvent('showSnack', { message: 'Não foi possível remover a cerca', type: 'error' });
      } else {
        logAction(`Remoção da cerca ${referencePoint.name}`);
        emitEvent('showSnack', { message: 'Cerca removida com sucesso', type: 'success' });
        redirect = true;
      }
    } catch (err) {
      console.log('Error', err);
    } finally {
      setLoadingDialog(false);
      setShowDialog(false);

      // Redirects to user list if everything was ok
      if (redirect) {
        history.push('/cercas');
      }
    }
  }

  // Render component
  return (
    
    <div>
      <ReferencePointForm
        title='Editar Ponto de Referência'
        handleCancel={handleCancel}
        referencePoint={referencePoint}
        setReferencePoint={setReferencePoint}
      />

      <ModalRemove
        isVisible={showDialog}
        setIsVisible={setShowDialog}
        titleLabel='do ponto de referência'
        onSubmit={handleRemoveConfirm}
        isLoading={loadingDialog}
        removeLabel='o ponto de referência'
        extraContent='Ao realizar está ação o ponto de referência não estará mais disponível.'
      />
    </div>
  );
}

export default EditFence;
